import React from 'react';

type InputType = 'text' | 'password' | 'email' | 'number';
type InputSize = 'sm' | 'md' | 'lg';
type InputRounded = 'md' | 'xl' | 'full';
type InputVariant = 'default' | 'chat';

interface CustomInputProps {
  value: string;
  onChange: (newValue: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  type?: InputType;
  size?: InputSize;
  rounded?: InputRounded;
  variant?: InputVariant;
  fullWidth?: boolean;
  autoComplete?: string;
  name?: string;
  id?: string;
}

export const CustomInput: React.FC<CustomInputProps> = ({
  value,
  onChange,
  placeholder = 'Enter text...',
  disabled = false,
  className = '',
  type = 'text',
  size = 'md',
  rounded = 'md',
  variant = 'default',
  fullWidth = false,
  autoComplete,
  name,
  id,
}) => {
  const sizeStyles = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 text-base',
    lg: 'h-11 px-4 text-base',
  };

  const roundedStyles = {
    md: 'rounded-lg',
    xl: 'rounded-xl',
    full: 'rounded-full',
  };

  const variantStyles = {
    default:
      'border border-line-soft bg-raised text-content placeholder:text-muted focus:ring-accent focus:border-transparent',
    chat: 'border border-primary-200 bg-surface text-content placeholder:text-muted focus:ring-primary-300 focus:border-primary-200',
  };

  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete={autoComplete}
      name={name}
      id={id}
      className={`transition-all focus:ring-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${
        sizeStyles[size]
      } ${roundedStyles[rounded]} ${variantStyles[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
    />
  );
};
